import { appApiSlice } from 'src/api/app-ApiSlice';

export const languageApiSlice = appApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getLanguageMessages: builder.query<any, void>({
      query: () => 'v1/language/get-language-messages',
    }),
  }),
  overrideExisting: false,
});

export const { useGetLanguageMessagesQuery } = languageApiSlice;